module.exports = __webpack_public_path__ + "img/hero-lg.0db5748b.png";